<div style="display: flex; height: 100%">
  <div style="display: flex;  background: #0B7FB8; width: 100%; align-content: center;   flex-wrap: wrap; justify-content: space-around;">
    <img src="../../../assets/maxresdefault 3.png" alt="logo" style="width: 40%; border-radius: 50%" />
  </div>
  <div style=" display: flex; width: 100%;  flex-direction: column;  justify-content: center; align-items: center;">
    <div class="fw-bold fs-2" style="color: #333; white-space: nowrap;">
      Hello Again!
    </div>
    <div class="mb-4 fs-4" style="font-size: 0.7rem; color: #333; white-space: nowrap;">
      Welcome Back
    </div>

    <div class="mt-1">
      <asl-google-signin-button type='standard' size='large' shape="pill" width="248"></asl-google-signin-button>
    </div>

  </div>
</div>

<p-toast [showTransitionOptions]="'1000ms'" [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'"></p-toast>
